import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { adminApi } from './adminApi';

const styles = `
  .data-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    overflow: hidden;
  }
  .data-table th {
    text-align: left;
    padding: 12px 16px;
    font-size: 0.78rem;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #EDE9E4;
    background: #FAFAF8;
  }
  .data-table td {
    padding: 13px 16px;
    font-size: 0.9rem;
    color: #2C2C2C;
    border-bottom: 1px solid #F0EDE8;
  }
  .data-table tr:last-child td { border-bottom: none; }
  .data-table tbody tr {
    cursor: pointer;
    transition: background 0.1s;
  }
  .data-table tbody tr:hover td { background: #FFF8F5; }
  .badge { display: inline-block; padding: 3px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; }
  .badge-sensitive { background: #FFF0EE; color: #C0392B; }
  .badge-ok { background: #F0FFF4; color: #27AE60; }
  .loading-state { color: #888; font-size: 0.9rem; padding: 20px 0; }
  .error-state { color: #C0392B; font-size: 0.9rem; padding: 20px 0; }
`;

function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });
}

export default function AdminConversations() {
  const navigate = useNavigate();
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi.listConversations()
      .then(data => setConvs(data || []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Conversations">
      <style>{styles}</style>

      {loading && <p className="loading-state">Loading…</p>}
      {error && <p className="error-state">Error: {error}</p>}

      {!loading && !error && (
        <table className="data-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Duration</th>
              <th>Turns</th>
              <th>Sensitive</th>
            </tr>
          </thead>
          <tbody>
            {convs.map(c => (
              <tr key={c.id} onClick={() => navigate(`/admin/conversations/${c.id}`)}>
                <td style={{ fontWeight: 600 }}>{c.user_name}</td>
                <td>{fmtDate(c.started_at)}</td>
                <td>{c.duration_mins > 0 ? `${c.duration_mins}m` : '—'}</td>
                <td>{c.turn_count}</td>
                <td>
                  {c.is_sensitive
                    ? <span className="badge badge-sensitive">Sensitive</span>
                    : <span className="badge badge-ok">Normal</span>
                  }
                </td>
              </tr>
            ))}
            {convs.length === 0 && (
              <tr>
                <td colSpan={5} style={{ color: '#888', textAlign: 'center', padding: '24px' }}>
                  No conversations yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
}
